import React from 'react';
import Sidebar from '../../components/Sidebar';
import './SidebarLayout.scss';

export default function SidebarLayout({ children }) {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
} 